<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>日志中心</el-breadcrumb-item>
    </el-breadcrumb>
    <div>
      <div class="mt-20">
        <el-tabs
          v-model="filter.record_type"
          @tab-click="handleTabClick"
          class="notice-tab"
          type="border-card"
        >
          <el-tab-pane name="1" label="登录日志" key="1">
            <div class="mt-20">
              <div class="filter">
                <el-form
                  :model="filter"
                  ref="filterForm"
                  label-position="left"
                  label-width="60px"
                  @submit.native.prevent
                >
                  <el-form-item label="操作人" prop="number">
                    <el-input
                      size="small"
                      :clearable="true"
                      v-model="filter.user_name"
                      placeholder="请输入账号名称"
                      autocomplete="off"
                      @keyup.enter.native="requestRecordList()"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="登录类型" prop="number">
                    <el-select
                      v-model="filter.category"
                      :clearable="true"
                      size="small"
                    >
                      <el-option label="登入" value="1" key="1"></el-option>
                      <el-option label="登出" value="40" key="40"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="操作时间" prop="date">
                    <el-date-picker
                      style="width: 360px"
                      v-model="filter.date"
                      type="daterange"
                      size="small"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-form>
                <div class="mt-10">
                  <el-button
                    type="primary"
                    size="small"
                    @click="requestRecordList()"
                    >筛选</el-button
                  >
                  <el-button size="small" @click="reset()">重置</el-button>
                </div>
              </div>
            </div>
            <div class="mt-20">
              <LoginRecord :records="records"></LoginRecord>
              <div class="mt-20">
                <el-pagination
                  class="mt-20"
                  :page-size="filter.size"
                  :current-page.sync="filter.page"
                  layout="total, prev, pager, next"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="2" label="操作日志" key="2">
            <div class="mt-20">
              <div class="filter">
                <el-form
                  :model="filter"
                  ref="filterForm"
                  label-position="left"
                  label-width="60px"
                  @submit.native.prevent
                >
                  <el-form-item label="操作人" prop="number">
                    <el-input
                      size="small"
                      :clearable="true"
                      v-model="filter.user_name"
                      placeholder="请输入账号名称"
                      autocomplete="off"
                      @keyup.enter.native="requestRecordList()"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="操作类型" prop="number">
                    <el-select
                      v-model="filter.category"
                      :clearable="true"
                      size="small"
                    >
                      <el-option
                        v-for="item in categoryOptions"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="操作时间" prop="date">
                    <el-date-picker
                      style="width: 360px"
                      v-model="filter.date"
                      type="daterange"
                      size="small"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-form>
                <div class="mt-10">
                  <el-button
                    type="primary"
                    size="small"
                    @click="requestRecordList()"
                    >筛选</el-button
                  >
                  <el-button size="small" @click="reset()">重置</el-button>
                </div>
              </div>
            </div>
            <div class="mt-20">
              <ApiRecord :records="records"></ApiRecord>
              <div class="mt-20">
                <el-pagination
                  class="mt-20"
                  :page-size="filter.size"
                  :current-page.sync="filter.page"
                  layout="total, prev, pager, next"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="3" label="推送日志" key="3">
            <div class="mt-20">
              <div class="filter">
                <el-form
                  :model="filter"
                  ref="filterForm"
                  label-position="left"
                  label-width="60px"
                  @submit.native.prevent
                >
                  <el-form-item label="操作人" prop="number">
                    <el-input
                      size="small"
                      :clearable="true"
                      v-model="filter.user_name"
                      placeholder="请输入账号名称"
                      autocomplete="off"
                      @keyup.enter.native="requestRecordList()"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="推送类型" prop="number">
                    <el-select
                      v-model="filter.category"
                      :clearable="true"
                      size="small"
                    >
                      <el-option label="邮件" value="60" key="60"></el-option>
                      <el-option
                        label="企业微信"
                        value="61"
                        key="61"
                      ></el-option>
                      <el-option label="短信" value="62" key="62"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="操作时间" prop="date">
                    <el-date-picker
                      style="width: 360px"
                      v-model="filter.date"
                      type="daterange"
                      size="small"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      value-format="yyyy-MM-dd"
                    ></el-date-picker>
                  </el-form-item>
                </el-form>
                <div class="mt-10">
                  <el-button
                    type="primary"
                    size="small"
                    @click="requestRecordList()"
                    >筛选</el-button
                  >
                  <el-button size="small" @click="reset()">重置</el-button>
                </div>
              </div>
            </div>
            <div class="mt-20">
              <PushRecord :records="records"></PushRecord>
              <div class="mt-20">
                <el-pagination
                  class="mt-20"
                  :page-size="filter.size"
                  :current-page.sync="filter.page"
                  layout="total, prev, pager, next"
                  :total="total"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- <div v-loading="loading">
          <el-table
            :data="notices"
            style="width: 100%"
            border
          >
            <el-table-column align="left" label="标题">
              <template slot-scope="scope">
                <i
                  class="os-icon os-icon-eye"
                  style="color: #2f7ef5"
                  v-if="scope.row.status == 1"
                ></i>
                {{ scope.row.notice.title }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              prop="notice.summary"
              label="摘要"
              min-width="120"
            ></el-table-column>
            <el-table-column align="center" label="发布者" width="150">
              <template slot-scope="scope">
                <span>
                  {{ showPublisher(scope.row.notice) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="发布时间" width="150">
              <template slot-scope="scope">
                <span>
                  {{ formatTime(scope.row.created_at) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="160">
              <template slot-scope="scope">
                <template>
                  <router-link
                    :to="'/dashboard/notices/detail/' + scope.row.notice.id"
                    v-permission="Auth.userNotice"
                  >
                    <el-button class="ml-10" type="primary" plain size="mini"
                      >详情</el-button
                    >
                  </router-link>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="mt-20"
            :page-size="filter.size"
            :current-page.sync="filter.page"
            layout="total, prev, pager, next"
            :total="total"
          ></el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { operationRecordList } from '@/service/getData'
import LoginRecord from './login_record.vue'
import ApiRecord from './api_record.vue'
import PushRecord from './push_record.vue'

const categoryOptions = [
  { value: 2, label: '新建客户' },
  { value: 3, label: '编辑客户' },
  { value: 4, label: '删除客户' },
  { value: 5, label: '恢复客户' },
  { value: 6, label: '新建设备' },
  { value: 7, label: '编辑设备' },
  { value: 8, label: '删除设备' },
  { value: 9, label: '新建拜访记录' },
  { value: 10, label: '新建报价' },
  { value: 34, label: '编辑报价' },
  { value: 11, label: '删除报价' },
  { value: 12, label: '新建商品' },
  { value: 13, label: '编辑商品' },
  { value: 15, label: '新建订单' },
  { value: 16, label: '编辑订单' },
  { value: 17, label: '新建翻新设备' },
  { value: 18, label: '编辑翻新设备' },
  { value: 19, label: '新建服务请求' },
  { value: 20, label: '编辑服务请求' },
  { value: 21, label: '新建公告' },
  { value: 22, label: '编辑公告' },
  { value: 23, label: '新建产品分类' },
  { value: 24, label: '编辑产品分类' },
  { value: 25, label: '删除产品分类' },
  { value: 26, label: '新建人员' },
  { value: 27, label: '编辑人员' },
  { value: 28, label: '新建角色' },
  { value: 29, label: '编辑角色' },
  { value: 30, label: '删除角色' },
  { value: 31, label: '新建流程' },
  { value: 32, label: '编辑流程' },
  { value: 33, label: '删除流程' },
]
export default {
  components: {
    LoginRecord,
    ApiRecord,
    PushRecord,
  },
  data() {
    return {
      categoryOptions,
      records: [],
      loading: false,
      total: 0,
      filter: {
        record_type: '1',
        user_name: '',
        category: '',
        date: '',
        page: 1,
        size: 20,
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.requestRecordList()
    },
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = this.filterDecode(this.$route.query.filter)
    }
    this.requestRecordList()
  },
  methods: {
    handleTabClick(tab, event) {
      this.reset()
    },
    async requestRecordList() {
      this.$router.replace({
        query: this.filterEncode(this.filter),
      })

      this.loading = true
      let data = this.clone(this.filter)
      data.page -= 1
      if (data.date && data.date.length == 2) {
        data.start_date = data.date[0]
        data.end_date = data.date[1]
      }

      let res = await operationRecordList(data)
      if (res.code == 0) {
        this.records = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    reset() {
      this.filter.user_name = ''
      this.filter.category = ''
      this.date = ''
      this.page = 1
      this.requestRecordList()
    },
  },
}
</script>

<style >
.notice-tab.el-tabs--border-card {
  border-bottom: none;
}
.notice-tab.el-tabs--border-card,
.notice-tab.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #ffffff;
}
.notice-tab.el-tabs--border-card > .el-tabs__content {
  padding-top: 0;
  padding-bottom: 0;
}

.el-tabs__content {
  padding: 20px !important;
}
</style>